<script>
  import MenuBar from './MenuBar.svelte';
  import Window from './Window.svelte';
  import Dock from './Dock.svelte';
  import AppSwitcher from './AppSwitcher.svelte';
  import DesktopIcons from './desktop/DesktopIcons.svelte';
  import MissionControl from './desktop/MissionControl.svelte';
  import DesktopSurface from './desktop/DesktopSurface.svelte';
  import HitCounter from './desktop/HitCounter.svelte';
  import ErrorBoundary from '../apps/ErrorBoundary.svelte';
  import { handleDesktopKeydown } from './desktop/desktop-shortcuts.js';
  import { windows, activeId as activeWindowId, launchApp } from '../os/windows.svelte.js';
  import { APPS } from '../os/apps.js';
  import { portfolio } from '../os/portfolio.svelte.js';
  import { session } from '../os/session.svelte.js';
  import { spacesState, toggleMissionControl } from '../os/spaces.svelte.js';

  const visibleApps = $derived(
    APPS.filter((app) => app.desktop !== false && (!app.adminOnly || session.role === 'admin'))
  );

  const activeId = $derived(
    windows
      .filter((w) => !w.minimized && w.spaceId === spacesState.activeSpaceId)
      .reduce((top, w) => (top && top.z > w.z ? top : w), null)?.id ?? null
  );

  const allSpaceWindows = $derived(
    windows.filter((w) => !w.minimized && w.spaceId === spacesState.activeSpaceId)
  );
  const fullscreenWindow = $derived(
    allSpaceWindows.filter((win) => win.fullscreen).sort((a, b) => b.z - a.z)[0] ?? null
  );
  const spaceWindows = $derived(fullscreenWindow ? [fullscreenWindow] : allSpaceWindows);
  const hasFullscreen = $derived(Boolean(fullscreenWindow));
</script>

<svelte:window onkeydown={handleDesktopKeydown} />

<DesktopSurface
  missionControlOpen={spacesState.missionControlOpen}
  reduceTransparency={portfolio.settings.reduceTransparency}
  reduceMotion={portfolio.settings.reduceMotion}
  highContrast={portfolio.settings.highContrast}
  {hasFullscreen}
  desktopTint={portfolio.settings.desktopTint}
  wallpaper={portfolio.settings.wallpaper}
  textScale={portfolio.settings.textScale ?? 1}
>
  <MenuBar />

  {#if portfolio.settings.showDesktopIcons && !spacesState.missionControlOpen}
    <DesktopIcons apps={visibleApps} />
  {/if}

  {#if !spacesState.missionControlOpen}
    {#each spaceWindows as win (win.id)}
      <Window {win} active={win.id === activeId}>
        {#if win.component}
          {@const Comp = win.component}
          <ErrorBoundary name={win.title ?? win.id}>
            <Comp windowId={win.id} {...win.props} />
          </ErrorBoundary>
        {/if}
      </Window>
    {/each}
  {/if}

  {#if spacesState.missionControlOpen}
    <MissionControl />
  {/if}

  {#if !spacesState.missionControlOpen && !hasFullscreen && session.role === 'admin'}
    <HitCounter />
  {/if}

  <Dock />
  <AppSwitcher />
</DesktopSurface>
